import { render, staticRenderFns } from "./UserDetailDrawer.vue?vue&type=template&id=572f7878"
import script from "./UserDetailDrawer.vue?vue&type=script&lang=js"
export * from "./UserDetailDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports